
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/css-for-kids",
      function () {
        return require("private-next-pages/courses/css-for-kids.tsx");
      }
    ]);
  